import { User, Log, LogLastEvaluatedKey } from "../lib/definitions";

export const fetchUsersByRating = async (): Promise<User[]> => {
  const url = "https://lt6jfngbhg.execute-api.ap-northeast-2.amazonaws.com/dev/api/ranking/rating"
  const response = await fetch(url, { cache: 'no-store' })
  const { data } = await response.json()
  return data.map((user: any) => {
    return {
      ...user,
      updatedAt: new Date(user.updatedAt),
    }
  })
}

export const fetchUser = async (handle: string): Promise<User> => {
  const url = `https://lt6jfngbhg.execute-api.ap-northeast-2.amazonaws.com/dev/api/user?handle=${handle}`
  const response = await fetch(url, { cache: 'no-store' })
  const data = await response.json()
  return {
    ...data,
    updatedAt: new Date(data.updatedAt),
  }
}

export const fetchLogs = async (handle: string, lastKey?: LogLastEvaluatedKey): Promise<{ logs: Log[], lastEvaluatedKey: LogLastEvaluatedKey}> => {
  const url = `https://lt6jfngbhg.execute-api.ap-northeast-2.amazonaws.com/dev/api/logs`
  const response = await fetch(url, {
    method: 'POST',
    body: JSON.stringify({
      handle,
      lastKey
    }),
    cache: 'no-store'
  })
  const { data } = await response.json()
  const { logs, lastEvaluatedKey } = data
  return {
    logs: logs.map((log: any) => {
      const minute = Math.floor(log.elapsedTime / 1000 / 60)
      const second = Math.floor(log.elapsedTime / 1000) % 60
      return {
        ...log,
        id: log.problemId + '#' + log.status,
        elapsedTime: `${minute}분 ${second}초`,
        createdAt: new Date(log.createdAt),
      }
    }),
    lastEvaluatedKey
  }
}